module.exports = "https://static.wmbcdn.com/uniweb/images/3995acab8642c339a6a2d56230e107d3.svg";